"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
interface FilterAccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  count?: number;
  rounded?: boolean;
}
export const FilterAccordion = t0 => {
  const $ = _c(23);
  const {
    title,
    children,
    defaultOpen: t1,
    count: t2,
    rounded
  } = t0;
  const defaultOpen = t1 === undefined ? true : t1;
  const count = t2 === undefined ? 0 : t2;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const t3 = `border-b border-slate-200 dark:border-slate-800 last:border-0 py-2 bg-white dark:bg-slate-850 ${rounded ? "rounded-xl" : ""}`;
  let t4;
  if ($[0] !== isOpen) {
    t4 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== count) {
    t5 = count > 0 && <span className="ml-2 text-brand-600">({count})</span>;
    $[2] = count;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5 || $[5] !== title) {
    t6 = <span className="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-white group-hover:text-brand-500 transition-colors">{title}{t5}</span>;
    $[4] = t5;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `ml-6 flex items-center transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FiChevronDown className="w-4 h-4 text-slate-400" />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <span className={t7}>{t8}</span>;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t4 || $[11] !== t6 || $[12] !== t9) {
    t10 = <button onClick={t4} className="flex items-center justify-between w-full py-3 md:py-2 px-4 text-left group focus:outline-none">{t6}{t9}</button>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = `overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-[500px] opacity-100 pb-4" : "max-h-0 opacity-0"}`;
  let t12;
  if ($[14] !== children) {
    t12 = <div className="space-y-2 mt-2 px-4">{children}</div>;
    $[14] = children;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10 || $[20] !== t13 || $[21] !== t3) {
    t14 = <div className={t3}>{t10}{t13}</div>;
    $[19] = t10;
    $[20] = t13;
    $[21] = t3;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};